/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const GlobalPhoneCaptureFragment = {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  GlobalPhoneCapture: gql`
    fragment GlobalPhoneCaptureQuery on stickyPhoneCapture_Entry {
      showStickyPhoneCapture
      displayMode
      coupon
      displayContent
      displayContentAfterSubmit
      buttonLabel
      saleStart
      saleEnd
      percentage
      countdownDays
    }
  `,
};
